// extracted by mini-css-extract-plugin
module.exports = {"text":"TextComponent_text__Nb3qY","title":"TextComponent_title___ZBaY","contentContainer":"TextComponent_contentContainer__GaA6z","content":"TextComponent_content__Aid6r"};